// @flow
import React, { PureComponent } from 'react';
import I18n from '../../../lib/i18n';
import Timeline from './Timeline';

const statusMapping = {
  inPreparation: I18n.t('Dashboard.Orders.orderStatus.inPreparation'),
  shipped: I18n.t('Dashboard.Orders.orderStatus.shipped'),
  delivered: I18n.t('Dashboard.Orders.orderStatus.delivered'),
};

export default class DeliveryTimeline extends PureComponent<Props> {
  render() {
    return <Timeline status={this.props.status} statusMapping={statusMapping} />;
  }
}

type Props = {
  status: 'inPreparation' | 'shipped' | 'delivered',
};
